import { Axios } from 'utils/AxiosConfig'

export const getSearchAgent = async (payload) => {
  const { data: response } = await Axios.get(`member/profile/search-agent`, payload)
  return response
}
export const postSearchAgent = async (payload) => {
  const { data: response } = await Axios.post(`member/profile/search-agent`, payload)
  return response
}
export const deleteSearchAgent = async (id) => {
  const { data: response } = await Axios.delete(`member/profile/search-agent/${id}`)
  return response
}
